import { useCallback, useRef } from "react";

import { useDipLifecycle } from "~/features/dataImportProjects/context";

type ResourceAuthorization = {
  resourceKey: string;
  authorized: boolean;
};

export function useDipResourceMutationGuard(resourceKey: string) {
  const { canExecuteMutation: canExecuteDipMutation } = useDipLifecycle();
  const authorizationRef = useRef<ResourceAuthorization>({ resourceKey, authorized: false });

  if (authorizationRef.current.resourceKey !== resourceKey) {
    authorizationRef.current = { resourceKey, authorized: false };
  }

  const canExecuteMutation = useCallback(
    () =>
      canExecuteDipMutation() &&
      authorizationRef.current.resourceKey === resourceKey &&
      authorizationRef.current.authorized,
    [canExecuteDipMutation, resourceKey],
  );
  const setAuthorized = useCallback(
    (authorized: boolean) => {
      if (authorizationRef.current.resourceKey !== resourceKey) return;
      authorizationRef.current.authorized = authorized;
    },
    [resourceKey],
  );

  return { canExecuteMutation, setAuthorized };
}
